module.exports = __webpack_public_path__ + "img/notification.f837cb25.png";